/* cx-cart-upsell.js
   Handles the "+ Add" buttons in the cart drawer's Frequently Bought Together section.
   Adds the variant via /cart/add.js requesting the re-rendered cart-drawer section, then
   swaps the drawer's inner HTML in place — no page reload. Event-delegated on document so
   it survives the drawer re-rendering, and guarded so it only binds once. */
(function () {
  if (window.cxCartUpsellInit) return;
  window.cxCartUpsellInit = true;

  // One add at a time. Without this, tapping "+ Add" on two rows before the first
  // request resolves lets each response overwrite the whole drawer — the slower one
  // wins and can paint a drawer missing the other item (server cart stays correct).
  var cxAddInFlight = false;

  function replaceSection(html, sourceSelector, liveEl) {
    if (!html || !liveEl) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(sourceSelector);
    if (fresh) liveEl.innerHTML = fresh.innerHTML;
  }

  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('.cx-fbt__add');
    if (!btn) return;
    event.preventDefault();

    if (cxAddInFlight || btn.dataset.loading === '1') return;

    var variantId = btn.dataset.variantId;
    if (!variantId) {
      // Multi-variant row with no model chosen yet — nudge the dropdown instead of adding.
      var pendingRow = btn.closest('.cx-fbt__row');
      var wrap = pendingRow && pendingRow.querySelector('.cx-fbt__select-wrap');
      if (wrap) {
        wrap.classList.remove('cx-fbt__shake');
        void wrap.offsetWidth;
        wrap.classList.add('cx-fbt__shake');
      }
      return;
    }

    cxAddInFlight = true;
    btn.dataset.loading = '1';
    btn.disabled = true;

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });

      if (!res.ok) throw new Error('add.js ' + res.status);
      var data = await res.json();
      var sections = data.sections || {};

      // Swap the drawer contents (items + upsell + footer all refresh; added row drops off).
      replaceSection(sections['cart-drawer'], '.drawer__inner', document.querySelector('#CartDrawer .drawer__inner'));
      // Keep the header cart-count bubble in sync.
      replaceSection(sections['cart-icon-bubble'], '.shopify-section', document.getElementById('cart-icon-bubble'));

      // The focused "+ Add" button was just destroyed by the re-render; move focus to the
      // drawer heading so keyboard/screen-reader users keep their place inside the drawer.
      var heading = document.querySelector('#CartDrawer .drawer__heading');
      if (heading) heading.focus();
    } catch (err) {
      console.error('CX cart upsell add failed:', err);
      // Re-enable so the customer can retry; fall back to a plain refresh if sections failed.
      btn.dataset.loading = '0';
      btn.disabled = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      cxAddInFlight = false;
    }
  });

  // Model dropdown → point the row's Add button at the chosen variant.
  // Capture phase + stopPropagation: the upsell lives INSIDE cart-drawer-items, and Dawn's
  // CartItems treats every bubbling `change` there as a quantity input (throwing
  // "increments of undefined"). Intercepting in capture stops it reaching Dawn.
  document.addEventListener(
    'change',
    function (event) {
      var sel = event.target.closest && event.target.closest('.cx-fbt__select');
      if (!sel) return;
      event.stopPropagation();
      var row = sel.closest('.cx-fbt__row');
      var btn = row && row.querySelector('.cx-fbt__add');
      if (btn) btn.dataset.variantId = sel.value || '';
    },
    true
  );
})();
